import React from "react";
import { Text, Flex, Card, Link, Table, TableCell, TableRow, TableBody } from "@jsq/ds/core";
import { toDbId } from "#utils/graphql_utils";
import { EntityBankAccountDisplay } from "../../../EntitySelector/EntityBankAccountDisplay";
import { EntityBankAccountFragment } from "../../../EntitySelector/types";
import { usePaymentsContext } from "../../Context/PaymentsContext";
import { PaymentBatchDetails } from "../types";
import {
  paymentOriginationDetailsCard,
  cardTitle,
  tableRow,
  sendFromSection,
} from "./styles_vanilla.css";

interface PaymentOriginationDetailsCardProps {
  paymentBatchDetails: PaymentBatchDetails;
  entityUrl: string;
}

const mapToEntityBankAccountFragment = (
  paymentBatchDetails: PaymentBatchDetails,
): EntityBankAccountFragment | null => {
  if (!paymentBatchDetails.bankAccount) {
    return null;
  }

  return {
    id: paymentBatchDetails.entityId,
    name: paymentBatchDetails.entityName,
    bankAccount: {
      id: paymentBatchDetails.bankAccount.id,
      bankName: paymentBatchDetails.bankAccount.bankName,
      bankInfoRedacted: paymentBatchDetails.bankAccount.bankInfoRedacted,
      ownerName: paymentBatchDetails.bankAccount.ownerName,
    },
  };
};

export const PaymentOriginationDetailsCard: React.FC<PaymentOriginationDetailsCardProps> = ({
  paymentBatchDetails,
  entityUrl,
}) => {
  const { isGPX } = usePaymentsContext();
  const selectedEntity = mapToEntityBankAccountFragment(paymentBatchDetails);
  const bankAccountUrl =
    paymentBatchDetails.hostName && paymentBatchDetails.bankAccount?.id
      ? `https://${paymentBatchDetails.hostName}/admin_settings/bank_account/${toDbId(
          paymentBatchDetails.bankAccount.id,
        )}`
      : null;

  return (
    <Card className={paymentOriginationDetailsCard}>
      <Flex flexDirection="column">
        <Text className={cardTitle} variant="secondary-md">
          DEBITING ACCOUNT DETAILS
        </Text>
        <Table condensed>
          <TableBody>
            {!isGPX && (
              <TableRow className={tableRow}>
                <TableCell>
                  <Text variant="secondary-md">Client</Text>
                </TableCell>
                <TableCell>
                  <Text variant="regular-md">{paymentBatchDetails.clientName}</Text>
                </TableCell>
              </TableRow>
            )}
            <TableRow className={tableRow}>
              <TableCell>
                <Text variant="secondary-md">Investment entity</Text>
              </TableCell>
              <TableCell>
                <Link
                  href={entityUrl}
                  align="left"
                  icon="external-link"
                  iconPosition="right"
                  shouldOpenInNewTab
                >
                  {paymentBatchDetails.entityName}
                </Link>
              </TableCell>
            </TableRow>
            {selectedEntity && (
              <TableRow className={tableRow}>
                <TableCell>
                  <Text variant="secondary-md">Send from:</Text>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {selectedEntity && (
          <Flex flexDirection="column" gap="small" className={sendFromSection}>
            <EntityBankAccountDisplay
              selectedEntity={selectedEntity}
              bankAccountUrl={bankAccountUrl}
            />
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
